import React, { FunctionComponent } from 'react';
import { DevicePhoneMobileIcon } from '@heroicons/react/20/solid';
import { Tooltip } from 'react-tooltip';
import { findProviderData } from '@app/component/provider/FindProviderData';
import MarketStateStatDateCompetitorLowestItem from '@app/model/market_state/MarketStateStatDateCompetitorLowestItem';
import MarketStateService from '@app/model/market_state/service/MarketStateService';


const RenderProviderWithIndicators: FunctionComponent<{
	lowestItem: MarketStateStatDateCompetitorLowestItem,
	marketStateIds: number[],
	afterProvider?: React.ReactNode
}> = ({ lowestItem, marketStateIds, afterProvider }) => {

	const onClick = () => {
		if (lowestItem.isAvailable)
			MarketStateService.constructMarketStateItemUrl(lowestItem.item.id, marketStateIds)
				.then(data => {
					if (!!data) {
						window.open(data, '_blank');
					}
				});
	};

	return <div className="flex items-center gap-x-2">
		{lowestItem.providerPlatforms.map((providerPlatform, index) => {
			return <span className="flex items-center gap-x-2" key={providerPlatform.provider}>
			<a className="cursor-pointer" onClick={onClick}>{findProviderData(providerPlatform.provider).icon}</a>
				{index === 0 && afterProvider}
				{(lowestItem.item.hasMemberDiscount || lowestItem.item.hasMobileDiscount) && renderIndicators(lowestItem)}
				<Tooltip id="image-tooltip" place="right"/>
		</span>;
		})}
	</div>;
};


const renderIndicators = (lowestItem: MarketStateStatDateCompetitorLowestItem) => {
	return <div className="flex items-center gap-x-1 bg-white rounded py-0.5 px-1 ring-1 ring-black ring-opacity-10">
		{lowestItem.item.hasMemberDiscount && loyaltyIcon}
		{lowestItem.item.hasMobileDiscount && <div className="flex-shrink-0 self-center">{mobileIcon}</div>}
	</div>;
};

const mobileIcon = <><DevicePhoneMobileIcon data-tooltip-id="mobile-tooltip"
																						data-tooltip-content="Special price for mobile"
																						className="w-4 h-4" /><Tooltip id="mobile-tooltip" /></>;
const loyaltyIcon = <><img alt="Loyalty program" data-tooltip-id="loyalty-tooltip"
													 data-tooltip-content="Loyalty program" className="block h-3.5 w-3.5"
													 src={'/assets/img/icons/medal-solid.svg'} /><Tooltip id="loyalty-tooltip" /></>;

export default RenderProviderWithIndicators;
